import React, { useContext, useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { Box } from "@mui/material";
import { checkUserPermission } from "../../../common/UserPermission";
import Loader from "../../../components/Loader/Loader";
import Sidebar from "../../Dashboard/Sidebar/Sidebar";
import CommonMatrialReactTable from "../../../components/Datatable/CommonMatrialReactTable";
import config from "../../../config/config";
import withReactContent from "sweetalert2-react-content";
import Swal from "sweetalert2";
import { toastError, toastSuccess } from "../../../common/Toast";
import { ERROR_MESSAGE, SUCCESS_MESSAGE } from "../../../common/Constant";
import { AppContext } from "../../../context/AppContext";
import QuickbookSyncMessageComponent from "../../../components/StoreConfig/QuickbookSyncMessageComponent";

function PaymentMethods() {
  const { QuickBookPaymentMethod, AllowQBSync } = useContext(AppContext);
  const MySwal = withReactContent(Swal);
  const token = localStorage.getItem("Token");
  const loginUserId = localStorage.getItem("ID");
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  // Reusable Styles
  const cellStyle = {
    borderRadius: "0.3rem",
    color: "#343f62",
    maxWidth: "18ch",
    fontWeight: "700",
    textUnderlineOffset: "3px",
    p: "0.3rem",
  };

  // State to store form data
  const [paymentMethod, setPaymentMethod] = useState({
    id: 0,
    methodName: "",
    showOnPayBill: false,
    showOnReceivePayment: false,
    PaymentQuickbookId: 0,
    ragisterpaymentmethodId: 1,
  });

  const [ragisterpaymentmethod, setragisterpaymentmethod] = useState([]);

  console.log(paymentMethod, "paymentMethod");

  const handleManageDataPopup = (data = null) => {
    setPaymentMethod(
      data
        ? {
            id: data?.id,
            methodName: data?.methodName || "",
            showOnPayBill: data?.showOnPayBill || false,
            showOnReceivePayment: data?.showOnReceivePayment || false,
            PaymentQuickbookId: data?.PaymentQuickbookId || 0,
            ragisterpaymentmethodId: data?.ragisterpaymentmethodId || 1,
          }
        : {
            id: 0,
            methodName: "",
            showOnPayBill: false,
            showOnReceivePayment: false,
            PaymentQuickbookId: 0,
            ragisterpaymentmethodId: 1,
          }
    );

    // Build options for the <select>
    const optionsHTML = ragisterpaymentmethod
      .map((el) => `<option>${el.label}</option>`)
      .join("");

    MySwal.fire({
      title: data ? "Update Payment Method" : "Add Payment Method",
      html: `
        <label class="form-label">Method Name</label>
        <input id="methodName" class="swal2-input" type="text" value="${
          data ? data.methodName : ""
        }" />
  
        
          <label class="form-label">Register Payment Method</label>
          <select id="ragisterpaymentmethod" class="swal2-select">
            ${optionsHTML}
          </select>
   
  
        <div style="text-align: left; margin-top: 10px;">
          <input type="checkbox" id="showOnPayBill" ${
            data?.showOnPayBill ? "checked" : ""
          }/>
          <label for="showOnPayBill" style="margin-left: 5px;">Show on PayBill</label>
        </div>
  
        <div style="text-align: left; margin-top: 10px;">
          <input type="checkbox" id="showOnReceivePayment" ${
            data?.showOnReceivePayment ? "checked" : ""
          }/>
          <label for="showOnReceivePayment" style="margin-left: 5px;">Show on Receive Payment</label>
        </div>
      `,
      showCancelButton: true,
      confirmButtonText: data ? "Update" : "Add",
      focusConfirm: false,
      didOpen: () => {
        // Attach event listeners
        document.getElementById("methodName").addEventListener("input", (e) => {
          setPaymentMethod((prev) => ({ ...prev, methodName: e.target.value }));
        });

        document
          .getElementById("ragisterpaymentmethod")
          .addEventListener("change", (e) => {
            setPaymentMethod((prev) => ({
              ...prev,
              ragisterpaymentmethodId: ragisterpaymentmethod.find(
                (el) => el.label == e.target.value
              )?.value,
            }));
          });

        document
          .getElementById("showOnPayBill")
          .addEventListener("change", (e) => {
            setPaymentMethod((prev) => ({
              ...prev,
              showOnPayBill: e.target.checked,
            }));
          });

        document
          .getElementById("showOnReceivePayment")
          .addEventListener("change", (e) => {
            setPaymentMethod((prev) => ({
              ...prev,
              showOnReceivePayment: e.target.checked,
            }));
          });

        document
          .getElementById("ragisterpaymentmethod")
          .addEventListener("change", (e) => {
            setPaymentMethod((prev) => ({
              ...prev,
              PaymentQuickbookId: Number(e.target.value),
            }));
          });
      },
      preConfirm: () => {
        const methodName = document.getElementById("methodName").value;
        const showOnPayBill = document.getElementById("showOnPayBill").checked;
        const showOnReceivePayment = document.getElementById(
          "showOnReceivePayment"
        ).checked;
        const ragisterpaymentmethodId = ragisterpaymentmethod.find(
          (el) =>
            el.label == document.getElementById("ragisterpaymentmethod").value
        ).value;

        console.log(ragisterpaymentmethodId,"items");
        
        if (!methodName) {
          Swal.showValidationMessage("Method Name is required");
          return false;
        }
        console.log(paymentMethod, " paymentMethod.ragisterpaymentmethodId,");

        return {
          id: data?.id || 0,
          methodName,
          showOnPayBill,
          showOnReceivePayment,
          PaymentQuickbookId: data?.PaymentQuickbookId || 0,
          loginUserId,
          ragisterpaymentmethodId,
        };
      },
    }).then((result) => {
      if (result.isConfirmed) {
        handleCreateUpdatePaymentMethod(result.value);
      }
    });
  };

  const handleMethodSync = () => {
    setLoading(true);
    let reqobj = { id: loginUserId };
    axios
      .post(
        `${config.accountingBaseUrl}/chartofaccounts/Paymentmethod`,
        reqobj,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            "Access-Control-Allow-Origin": "*",
          },
        }
      )
      .then((res) => {
        console.log("rescheck", res);
        if (
          res?.data?.ResponseCode == "SUCCESS" &&
          res?.data?.ResponseData[0]?.ID > 0
        ) {
          toastSuccess(
            "Successfully synced payment methods from QuickBook to POS"
          );
          setLoading(false);
        } else {
          toastError(ERROR_MESSAGE);
          setLoading(false);
        }
      })
      .catch((error) => {
        setLoading(false);
      });
  };


  const TermsSync = () => {
    setLoading(true);


      axios.get(`${config.accountingBaseUrl}/chartofaccounts/Termsync?loginUserId= 1`)
      .then((res) => {
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
      })
  }

  // Handle Delete Popup
  const handleDeletePopup = (data) => {
    Swal.fire({
      title: "Are you sure?",
      text: "This action cannot be undone!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "No, cancel",
    }).then((result) => {
      if (result.isConfirmed) {
        handleDeletePaymentMethod(data);
      }
    });
  };

  // API Calls
  const handleCreateUpdatePaymentMethod = async (data) => {
    console.log("Creating Payment Method:", data);
    setLoading(true);
    axios
      .post(
        `${config.accountingBaseUrl}/chartofaccounts/paymentmethodupsert`,
        data,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        if (res.data.ResponseID > 0 && res.data.ResponseCode === "SUCCESS") {
          toastSuccess(res.data.ResponseMessage);
          getPaymentMethodApi();
        } else {
          toastError(res.data.ResponseMessage);
        }
      })
      .catch((err) => console.log(err));
    setLoading(false);
  };

  const handleDeletePaymentMethod = async (data) => {
    console.log("Deleting Payment Method ID:", data);
    setLoading(true);
    axios
      .post(
        `${config.accountingBaseUrl}/chartofaccounts/paymentmethoddelete`,
        {
          id: data.ID,
          loginUserId,
          PaymentQuickbookId: data.PaymentQuickbookId,
        },
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        if (res.data.ResponseID > 0 && res.data.ResponseCode === "SUCCESS") {
          toastSuccess(res.data.ResponseMessage);
          getPaymentMethodApi();
        } else {
          toastError(res.data.ResponseMessage);
        }
      })
      .catch((err) => console.log(err));
    setLoading(false);
    // Call API to delete the payment method
  };

  const getPaymentMethodApi = () => {
    setLoading(true);
    axios
      .get(`${config.generalBaseUrl}/generals/paymentdropdown`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        setData(res.data?.ResponseData);
      })
      .catch((err) => console.log(err));

    axios
      .get(`${config.salesconfigBaseUrl}/sales/ragisterpaymentmethod`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
        },
      })
      .then((res) => {
        let option = res.data.ResponseData.map((el) => ({
          label: el.PaymentName,
          value: el.ID,
        }));
        setragisterpaymentmethod(option);
      })
      .catch((err) => console.log(err));
    setLoading(false);
  };

  useEffect(() => {
    getPaymentMethodApi();
  }, []);

  const columns = useMemo(
    () => [
      // { header: "ID", accessorKey: "ID", size : 80  },
      {
  header: "ID",
  accessorKey: "ID",
  size: 80,
  Cell: ({ row }) => {
    const isCompleted = Number(row.original.PaymentQuickbookId) > 0;

    return (
      <Box display="flex" alignItems="center" gap={1}>
        <Box
          sx={{
            width: 8,
            height: 8,
            borderRadius: "50%",
            backgroundColor: isCompleted
              ? "var(--success-main-color)"
              : "var(--error-main-color)",
          }}
        />
        <span>{row.original.ID}</span>
      </Box>
    );
  },
},
      { header: "Name", accessorKey: "Paymenttypename", size:120 },
      {
        header: "isInReceivePayment",
        accessorKey: "receivepayment",
        Cell: ({ row }) => (
          <Box component="span" sx={cellStyle}>
            {row.original.receivepayment === 1 ? "Active" : "-"}
          </Box>
        ),
      },
      {
        header: "isInPayBill",
        accessorKey: "paybill",
        Cell: ({ row }) => (
          <Box component="span" sx={cellStyle}>
            {row.original.paybill === 1 ? "Active" : "-"}
          </Box>
        ),
        size:120
      },
      {
        header: "Sync QB Status",
        accessorKey: "PaymentQuickbookId",
        Cell: ({ row }) => (
          <Box
            component="span"
            sx={{
              ...cellStyle,
              color:
                row.original.PaymentQuickbookId > 0
                  ? "var(--success-main-color)"
                  : "var(--error-main-color)",
            }}
          >
            {row.original.PaymentQuickbookId > 0 ? "Completed" : "Failed"}
          </Box>
        ),
        size:150
      },
      { header: "Link Payment Type for Register", accessorKey: "PaymentName",
        Cell: ({ row }) => (
          <Box
            component="span"
            sx={cellStyle}
            className={`${row.original.PaymentName == null ? "cursor-pointer" : ""}`}
            onClick={() => {
              if (row.original.PaymentName == null) {
                handleManageDataPopup({
                  id: row.original.ID,
                  methodName: row.original.Paymenttypename,
                  showOnPayBill: row.original.paybill === 1,
                  showOnReceivePayment: row.original.receivepayment === 1,
                  PaymentQuickbookId: row.original.PaymentQuickbookId,
                });
              }
            }}
          >
            {row.original.PaymentName == null ? "Link Now" : row.original.PaymentName}
          </Box>
        )
       },
    ],
    []
  );

  // Row Actions
  const renderRowActions = ({ row }) => (
    <div>
      {checkUserPermission("/paymentmethods") && (
        <Link
          className="btn btn-primary"
          to="#"
          onClick={() =>
            handleManageDataPopup({
              id: row.original.ID,
              methodName: row.original.Paymenttypename,
              showOnPayBill: row.original.paybill === 1,
              showOnReceivePayment: row.original.receivepayment === 1,
              PaymentQuickbookId: row.original.PaymentQuickbookId,
            })
          }
        >
          Edit
        </Link>
      )}
      {checkUserPermission("/paymentmethodsdelete") && (
        <Link
          className="btn btn-sm btn-secondary confirm-text ml-2"
          to="#"
          title="Delete"
          onClick={() => handleDeletePopup(row.original)}
        >
          Delete
        </Link>
      )}
    </div>
  );

  return (
    <>
      <Loader loading={loading} />
      <Sidebar />
      <div className="page-wrapper cardhead">
        <div className="content">
          <div
            className="page-header"
            style={{
              position: "fixed",
              top: "2px",
              zIndex: "999",
            }}
          >
            <div className="row breadcrumb-position">
              {/* <h3 className="page-title">Inventory: Brand</h3> */}
              <ul className="breadcrumb" style={{ marginLeft: "12px" }}>
                <li className="breadcrumb-item">
                  <Link to="/dashboard">Dashboard</Link>
                </li>
                <li className="breadcrumb-item active">
                  Manage Payment Method
                </li>
              </ul>
            </div>
          </div>
          <div className="d-flex justify-content-end mb-3">
            <div className="page-btn">
              {checkUserPermission("/paymentmethods") && (
                <>
                  <Link
                    to="#"
                    className="btn btn-primary btn-sm"
                    style={{ width: "max-content" }}
                    onClick={() => handleManageDataPopup()}
                  >
                    <i className="fa fa-plus me-2 lg"></i>
                    Add Payment Method
                  </Link>

                  <Link
                    onClick={() => handleMethodSync()}
                    className="btn btn-primary btn-sm ms-2"
                    style={{ width: "max-content" }}
                  >
                    Sync Methods From QB
                  </Link>
                  <Link
                    onClick={() => TermsSync()}
                    className="btn btn-primary btn-sm ms-2"
                    style={{ width: "max-content" }}
                  >
                    Sync Terms From QB
                  </Link>
                </>
              )}
            </div>
          </div>

          <div className="card">
            <div className="card-body" style={{ padding: "0px 20px 0 20px" }}>
              <div className="card-body pb-0">
                {!QuickBookPaymentMethod && AllowQBSync && (
                  <QuickbookSyncMessageComponent type="Payment Methods" />
                )}
                <div className="table-responsive">
                  <CommonMatrialReactTable
                    columns={columns}
                    data={data}
                    hodiExport={true}
                    enableRowSelection={false}
                    enableRowActions={true}
                    renderRowActions={renderRowActions}
                    isRowSelectionManual={true}
                    // setRowSelectData={setRowSelection}
                    // setColumnOrder={setColumnOrder}
                    state={
                      {
                        //   columnOrder,
                        //   rowSelection,
                      }
                    }
                    // renderRowActionMenuItems={renderRowActionMenuItems}
                  />
                </div>
              </div>
            </div>
          </div>
          {/* /Data list */}
        </div>
      </div>
    </>
  );
}

export default PaymentMethods;
